import React, { useEffect, useState } from 'react'
import { useForm } from 'antd/lib/form/Form'
import { message } from 'antd'
import { useAppContext } from '@/components/AppContext'
import { Product } from '@a4b/api/src/modules/Monetisation/Puja/types'
import { A4B_APPS } from '@/utils/constants'
import { formatItemCreation } from './helper'
import ItemCreation from '../ItemCreation'
import { openErrorNotification } from '@/utils'

interface Props {
  showItemCreation: boolean
  isEditJourney: boolean
  closeItemCreation: (fetchProductList: boolean) => void
  formData?: Product
}

const CreateItem: React.FC<Props> = ({
  showItemCreation,
  closeItemCreation,
  isEditJourney,
  formData,
}) => {
  const { networkInstance, app, countryState, languageState } = useAppContext()
  const monetisationPujaApi = app === A4B_APPS.SRIMANDIR ? networkInstance.clientWithHeaders.monetisationPujaApi : networkInstance.clientWithHeaders.monetisationAstroPujaApi

  const [editFormData, setEditFormData] = useState<any>()
  const [createItemForm] = useForm()

  useEffect(() => {
    if (isEditJourney) {
      const editForm = {
        ...formData,
        id: formData?.id,
        name: formData?.title,
        image_url: [formData?.image_url],
        intro_video_url: [formData?.intro_video_url],
        outro_video_url: [formData?.outro_video_url],
        bottomsheet_medias: formData?.bottomsheet_medias?.map((item) => item?.media_url),
        is_igst: formData?.is_igst ?? false,
        hsn_code: formData?.hsn_code,
        tax_rate: formData?.tax_rate,
        slug: formData?.slug,
        additional_info_v2: formData?.additional_info_v2 || [],
        bullet_icon_url: [formData?.bullet_icon_url],
        specificity: formData?.specificity,
        // language_code: formData?.language_code,
        // country_code: formData?.country_code,
        batch_size: formData?.batch_size,
        quantities: formData?.quantities,
        member_size: formData?.member_size,
        master_product_id: formData?.master_product_id,
        currency: formData?.currency,
        multi_add: formData?.multi_add,
        deliverable: formData?.deliverable,
        short_name: formData?.short_name,
      }
      setEditFormData(editForm)
      createItemForm.setFieldsValue(editForm)
    } else {
      setTimeout(() => {
        createItemForm.resetFields()
        createItemForm.setFieldsValue({
          language_code: languageState.monetisationLanguage,
          country_code: countryState.countryCode,
          currency: countryState.countryCode === "IN" ? "INR" : "USD"
        })
      }, 300)
      setEditFormData({})
    }
  }, [isEditJourney, formData, createItemForm, languageState, countryState])

  const handleCreateOrUpdate = async (values: any) => {
    const parsedData = formatItemCreation(values, languageState.monetisationLanguage, countryState.countryCode)
    if (isEditJourney) {
      try {
        const id = formData?.master_product_id || ''
        await monetisationPujaApi.productApi.updateItem(
          { ...parsedData },
          id,
          countryState?.countryCode,
        )
        message.success('Item updated successfully')
        createItemForm.resetFields()
        closeItemCreation(true)
      } catch (error: any) {
        openErrorNotification(error)
      }
    } else {
      try {
        message.loading({ content: 'Creating item...', key: 'create-item' })
        await monetisationPujaApi.productApi.createItem(
          parsedData,
          countryState?.countryCode,
        )
        message.success({
          content: 'Item Created Successfully',
          duration: 2,
          key: 'create-item',
        })
        createItemForm.resetFields()
        closeItemCreation(true)
      } catch (error: any) {
        openErrorNotification(error)
      }
    }
  }

  const formSubmithandler = () => {
    createItemForm
      .validateFields()
      .then(values => {
        console.log('Form values before submission:', values);
        handleCreateOrUpdate(values)
      })
      .catch(errorInfo => {
        console.error('Form validation failed:', errorInfo);
        message.error("Form validation failed")
      })
  }

  return (
    <ItemCreation
      visible={showItemCreation}
      onClose={closeItemCreation}
      formSubmithandler={formSubmithandler}
      form={createItemForm}
      initialValues={editFormData}
      isEditJourney={isEditJourney}
    />
  )
}

export default CreateItem
